// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CrowdstrikeIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="#FC0000"
      d="M45.5 46C44 42.57 41 38.17 29.2 31.9c-5.43-3.03-14.71-7.68-23.06-16.53.76 3.2 4.64 10.2 21.3 18.96 4.63 2.53 12.44 4.9 18.06 11.66M44.74 40.13c-1.42-4.05-3.99-9.24-16.16-16.94C22.65 19.31 13.95 14.43 2.5 2c.82 3.35 4.44 12.07 22.68 23.38 5.99 4.06 13.72 6.57 19.56 14.75"
    />
  </svg>,
  "Crowdstrike",
);
export default CrowdstrikeIcon;
